import { trackingEvent } from '@notino/web-tracking';

import { dispatchEcommerceMessage } from '@services/messagingService';

import { EcommerceSectionNamespace } from '../../../model';

export const trackServiceInfoModalOpen = (time: number, name: string) => {
  dispatchEcommerceMessage(
    trackingEvent({
      event: EcommerceSectionNamespace.EEcommerceEvent.SUBPAGE_VIEW,
      subpage: {
        name: name,
        type: EcommerceSectionNamespace.EEcommerceType.CHECKOUT_SERVICE,
        interaction: EcommerceSectionNamespace.EEcommerceInteraction.CLICK_LINK,
        timing: time,
        unified_name: EcommerceSectionNamespace.EEcommercePageViewUnifiedName.SERVICE_INFO_MODAL,
        title: name,
      },
      _clear: true,
    }),
  );
};
